import styled, { createGlobalStyle } from 'styled-components';
import { animated } from '@react-spring/web';
import { ResponsiveWidth } from '../../../../components/Css';
import { motion } from 'framer-motion';

const animation = {
  initial: {opacity: 0, y: 20},
  animate: {opacity: 1, y: 0},
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};

export const OverlayContainer = styled(animated.div)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;


    z-index: 1000;

    @media (min-width: ${ResponsiveWidth}px) {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 400px;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-regular);
    color: var(--colorTextPrimary);
    height: 73px;
    margin-top: var(--spacing-regular);
    margin-bottom: var(--spacing-regular);
`;

export const LogoContainer = styled.div`
    cursor: pointer;
`;

export const Content = styled(motion.div).attrs(() => animation)`
    height: auto;
    margin-top: var(--spacing-regular);
    margin-bottom: var(--spacing-regular);
    border-radius: var(--borderRadiusBase) var(--borderRadiusBase) 0px 0px;
    background-color: var(--colorBgContainer);
    color: var(--colorBgTextContainer);
    width: calc(100% - var(--spacing-regular) - var(--spacing-regular));
    padding: var(--spacing-regular) var(--spacing-regular);

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    @media (min-width: ${ResponsiveWidth}px) {
        border-radius: var(--borderRadiusBase);
        max-width: ${ResponsiveWidth}px;

        display: flex;
        justify-content: center;
        align-items: start;
    }

`;

export const Container = styled.div`
    margin: 0 auto;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`

export const NavigationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: var(--spacing-regular);
    font-size: var(--font-medium);
    color: var(--color-highlight);
    cursor: pointer;

    @media (max-width: 1280px) {
        margin-bottom: var(--spacing-small);
    }
`;

export const TitleWrapper = styled.div<{ $customStyles?: any }>`
    display: flex;
    margin-bottom: var(--spacing-regular);
    width: 100%;
    margin-top: var(--spacing-regular);

    color: var(--color-neutral-dark);
    font-size: var(--font-giant);
    font-weight: bold;

    ${props => props.$customStyles && `
        margin-bottom: ${props.$customStyles.marginBottom || 'var(--spacing-regular)'} !important;
        margin-top: ${props.$customStyles.marginTop || 'var(--spacing-regular)'} !important;
        font-size: ${props.$customStyles.fontSize || 'var(--font-giant)'} !important;
        color: ${props.$customStyles.color || 'var(--color-neutral-dark)'} !important;
        font-weight: ${props.$customStyles.fontWeight || 'bold'} !important;
    `}

    @media (max-width: 1280px) {
        margin-top: var(--spacing-small);
        margin-bottom: var(--spacing-small);
        font-size: var(--font-regular);
    }
`;

export const ChildrenWrapper = styled.div`
    flex: 1;
`;

export const FooterDivContainer = styled.div`
    width: calc(100%);
    display: flex;
    justify-content: flex-end;
    margin-top: auto; /* Empurra para o final do container flexível */
    padding-top: var(--spacing-regular);
`;

export const TitleFmlStyle = createGlobalStyle`
  .title-fml {
    font-size: var(--title-font-size-fml);
    margin-bottom: var(--title-margin-bottom-fml);
  }
`;
